import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { PreInitSettingsService } from './settings/pre-init-setting.service';
import { PGHOktaService } from './pghokta.service';

@Injectable({
  providedIn: 'root'
})
export class ReceiptService {
  private middlewareUrl: string;
  private accountPath: string;
  private deviceInventoryMiddlewareUrl: string;
  private deviceInventoryGraphQlUrl: string;
  private accessToken: string;


  constructor(private httpClient: HttpClient, private pghOktaService: PGHOktaService, private preInitSettingsService: PreInitSettingsService,) {
    this.middlewareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    this.accountPath = this.preInitSettingsService.getSettings().middleWare.accountPath;
    this.deviceInventoryMiddlewareUrl = this.preInitSettingsService.getSettings().middleWare.deviceInventoryMiddlewareUrl;
    this.deviceInventoryGraphQlUrl = `${this.deviceInventoryMiddlewareUrl}/graphql`;
    this.accessToken = this.pghOktaService.getAccessToken();
  }

  uploadReceiptFile(registeredDeviceIdentifier: string, image: string, extension: string,childCertificateNumber: string, dealerCode : string ) : Observable<any> {
     const body = {
          CertificateNumber: childCertificateNumber,
          DealerCode: dealerCode,
          ImageData: image,
          FileExtension: extension,
          DeviceIdentifier: registeredDeviceIdentifier
        };
        return this.httpClient.post<any>(`${this.middlewareUrl}${this.accountPath}updload-receipt`, body);
  }

  // uploadReceiptFile(deviceId: Number, image: string, extension: string) {
  //   const headers: HttpHeaders = new HttpHeaders({
  //     'Content-Type': 'application/json; charset=utf-8',
  //     'Authorization': `Bearer ${this.accessToken}`,
  //     'Accept': 'application/json'
  //   });

  //   const graphql = JSON.stringify({
  //     query: 'mutation uploadDeviceReceipt ($input: UploadDeviceReceiptInput!){\n    uploadDeviceReceipt (input: $input) {\n    id\n    make\n    model\n    hasReceipt\n    receipt\n    createdAt\n    updatedAt\n    }\n}',
  //     variables: {
  //       input: {
  //         id: deviceId,
  //         extension: extension,
  //         image: image,
  //       },
  //     }
  //   });

  //   return this.httpClient.post<any>(this.deviceInventoryGraphQlUrl, graphql, { headers: headers })
  //     .pipe(
  //       map(res => {
  //         this.assertGraphQlResponseIsErrorFree(res, this.deviceInventoryGraphQlUrl);
  //         return res?.data?.uploadDeviceReceipt;
  //       }),
  //     );
  // };

  getReceiptImage(imageGuid: string, certificateNumber: string, dealerCode: string) : Observable<any>  {
    const body = {
        CertificateNumber: certificateNumber,
        DealerCode: dealerCode,
      ImageId: imageGuid
    }
     return this.httpClient.post<any>(`${this.middlewareUrl}${this.accountPath}download-receipt`, body);
    // HMS TODO: need to implement the Elita version of this
  }

  // getReceiptImage(deviceId: number, inventoryId: number): Observable<any> {
  //   const headers: HttpHeaders = new HttpHeaders({
  //     'Content-Type': 'application/json; charset=utf-8',
  //     Authorization: `Bearer ${this.accessToken}`,
  //     Accept: 'application/json'
  //   });

  //   const graphql = JSON.stringify({
  //     query: `query device ($input: DeviceInput!){
  //       device(input: $input) {
  //           deviceType {
  //               id
  //           },
  //           inventoryId,
  //           receipt
  //       }
  //   }`,
  //     variables: { input: { id: deviceId, inventoryId: inventoryId } }
  //   });

  //   return this.httpClient.post<any>(this.deviceInventoryGraphQlUrl, graphql, { headers: headers })
  //     .pipe(
  //       map(res => {
  //         this.assertGraphQlResponseIsErrorFree(res, this.deviceInventoryGraphQlUrl);
  //         return res?.data?.device?.receipt;
  //       }),
  //     );
  // }

  // private assertGraphQlResponseIsErrorFree(response: any, url: string) {
  //   if ((response?.errors?.length ?? 0) > 0) {
  //     throw new HttpErrorResponse({
  //       error: response,
  //       status: 400,
  //       url: url,
  //     });
  //   }
  // }
}
